import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { MemberStore } from '../../store/member/member.store';

export const memberOnboardingMatchGuard: CanActivateFn = async (route, segments) => {
  const memberStore = inject(MemberStore)
  const router = inject(Router)
  return memberStore.active() == false ? true : router.createUrlTree(['/member'])
}